import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Element)
import { Button, Form, FormItem, Input, Message, Container, Header,
    Aside, Main, Menu, Submenu, MenuItemGroup, MenuItem, Breadcrumb,
    BreadcrumbItem, Card, Row, Col, Table, TableColumn, Switch, Tooltip, Pagination,
    Dialog, MessageBox, Tag, Tree, Select, Option, Cascader, Alert, Tabs, TabPane,
    Step, Steps, Checkbox, CheckboxGroup, Upload,
    Timeline, TimelineItem,DatePicker ,Popover,
    Collapse ,CollapseItem, Dropdown ,DropdownMenu,DropdownItem,
    RadioGroup,Radio,
  } from 'element-ui'
  Vue.use(DatePicker)
  Vue.use(Button)
  Vue.use(Form)
  Vue.use(FormItem)
  Vue.use(Input)
  Vue.use(Container)
  Vue.use(Header)
  Vue.use(Aside)
  Vue.use(Main)
  Vue.use(Menu)
  Vue.use(Submenu)
  Vue.use(MenuItemGroup)
  Vue.use(MenuItem)
  Vue.use(Breadcrumb)
  Vue.use(BreadcrumbItem)
  Vue.use(Card)
  Vue.use(Row)
  Vue.use(Col)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Switch)
  Vue.use(Tooltip)
  Vue.use(Pagination)
  Vue.use(Dialog)
  Vue.use(Tag)
  Vue.use(Tree)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Cascader)
  Vue.use(Alert)
  Vue.use(Tabs)
  Vue.use(TabPane)
  Vue.use(Step)
  Vue.use(Steps)
  Vue.use(Checkbox)
  Vue.use(CheckboxGroup)
  Vue.use(Upload)
  Vue.use(Timeline)
  Vue.use(TimelineItem)
  Vue.use(DatePicker)
  Vue.use(Popover)
  Vue.use(Collapse)
  Vue.use(CollapseItem)
  Vue.use(Dropdown)
  Vue.use(DropdownMenu)
  Vue.use(DropdownItem)
  Vue.use(RadioGroup)
  Vue.use(Radio)
Vue.prototype.$message = Message